var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9255_10844",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9255_10844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 21C12.7167 21 12.4792 20.9042 12.2875 20.7125C12.0958 20.5208 12 20.2833 12 20C12 19.7167 12.0958 19.4792 12.2875 19.2875C12.4792 19.0958 12.7167 19 13 19H19V5H13C12.7167 5 12.4792 4.90417 12.2875 4.7125C12.0958 4.52083 12 4.28333 12 4C12 3.71667 12.0958 3.47917 12.2875 3.2875C12.4792 3.09583 12.7167 3 13 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H13ZM11.175 13H4C3.71667 13 3.47917 12.9042 3.2875 12.7125C3.09583 12.5208 3 12.2833 3 12C3 11.7167 3.09583 11.4792 3.2875 11.2875C3.47917 11.0958 3.71667 11 4 11H11.175L9.3 9.125C9.11667 8.94167 9.025 8.71667 9.025 8.45C9.025 8.18333 9.11667 7.95 9.3 7.75C9.48333 7.55 9.71667 7.44583 10 7.4375C10.2833 7.42917 10.525 7.525 10.725 7.725L14.3 11.3C14.5 11.5 14.6 11.7333 14.6 12C14.6 12.2667 14.5 12.5 14.3 12.7L10.725 16.275C10.525 16.475 10.2875 16.5708 10.0125 16.5625C9.7375 16.5542 9.5 16.45 9.3 16.25C9.11667 16.05 9.02917 15.8125 9.0375 15.5375C9.04583 15.2625 9.14167 15.0333 9.325 14.85L11.175 13Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/Login.5a8d39c16cee731d5b5fb1e0d663666b.svg";
export { ForwardRef as ReactComponent };